import { useUnit } from "effector-react";
import { useEffect } from "react";
import {
  $goalsStore,
  fetchMatchingCallsRequested,
  loadMoreMatchingCallsRequested,
} from "../store";
import { FundingGoal, MatchingCallsFilters } from "../model/types";
import { CallFilters } from "@/features/calls/model/types";

export const useMatchingCallsViewModel = (
  goal: FundingGoal | null,
  filters?: MatchingCallsFilters
) => {
  const [goalsState, fetchMatchingCalls, loadMore] = useUnit([
    $goalsStore,
    fetchMatchingCallsRequested,
    loadMoreMatchingCallsRequested,
  ]);

  const hasMoreCalls = (): boolean => {
    return goalsState.matchingCalls.length < Number(goalsState.calls_total_count);
  };

  const fetchMatchingCallsWithFilters = (
    filters?: MatchingCallsFilters,
    silent?: boolean,
  ) => {
    if (goal) {
      fetchMatchingCalls({ goalId: goal.id, filters, silent });
    }
  };

  const loadMoreCallsWithFilters = (filters?: MatchingCallsFilters) => {
    loadMore(filters);
  };

  // Remove the useEffect that was causing infinite loops
  // Data fetching is now handled by the page component

  return {
    calls: goalsState.matchingCalls,
    loading: goalsState.loading,
    loadMore: goalsState.loadMore,
    hasMoreCalls,
    loadMoreCalls: loadMoreCallsWithFilters,
    fetchMatchingCallsWithFilters,
    error: goalsState.error,
    goalsState,
  };
};
